import React from 'react'

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FormSelect from "../../../components/atoms/Select";
import {
    agregarStringAArraydDeStringsSiNoExiste,
    eliminarStringDeArraydDeStrings,
    handleFind,
    stringSeEncuentraEnArray
} from "../../../helper/utils";
import PageTable from "../../../components/pageComponents/PageTable";
import ActionsIcons from "../../../components/atoms/ActionsIcons";
import DetalleFalta from "./modales/DetalleFalta";

const TableFaltas = ({
                         formValues,
                         setFormValues,
                         extraData,
                         setModalEnabled,
                         paginator,
                         setPaginator,
                         keys: KEYS,
                         idsFaltasConCheck,
                         setIdsFaltasConCheck,
                         manageSearch,
                         fromAdminPage
                     }) => {
    const rows = formValues.Items;

    const HEADERS = [
        {col: "col-sm-1", label: "Fecha de Registro"},

        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsTipoFaltas)}
                        description="Tipo Falta"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsTipoFaltas] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsTipoFaltas)}
                    />
                </div>
        },
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsEstadosEmpleado)}
                        description="Est. Empleado"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstadosEmpleado] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstadosEmpleado)}
                    />
                </div>
        },
        {col: "col-sm-2", label: "Nombre"},
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsDepartamentos)}
                        description="Departamento"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsDepartamentos] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsDepartamentos)}
                    />
                </div>
        },
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsCargos)}
                        description="Cargo"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsCargos] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsCargos)}
                    />
                </div>
        },
        {
            col: "col-sm-2", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsSedes)}
                        description="Sede"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsSedes] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsSedes)}
                    />
                </div>
        },


        {col: "col-sm-1", label: "Fecha de Inicio"},
        {col: "col-sm-1", label: "Fecha de Fin"},
        {col: "col-sm-1", label: "Cantidad días"},
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsEstados)}
                        description="Est.Solicitud"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstados] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstados)}
                    />
                </div>
        },

        {col: "", label: "Acciones"},
    ]

    const handleFilterSelected = (res, key) => {
        const updatedSelectedFilters = {...formValues.selectedFilters, [key]: res};
        setFormValues(lastData => ({...lastData, selectedFilters: updatedSelectedFilters}));
    }

    const checkboxClic = (e, row) => {
        let value = e.target.checked;
        let idFalta = row["IdFalta"];
        let tempIds = [...idsFaltasConCheck];
        if (value === true && !stringSeEncuentraEnArray(idFalta, tempIds)) {
            tempIds = agregarStringAArraydDeStringsSiNoExiste(idFalta, tempIds);
            setIdsFaltasConCheck(tempIds);
        } else if (value === false && stringSeEncuentraEnArray(idFalta, tempIds)) {
            tempIds = eliminarStringDeArraydDeStrings(idFalta, tempIds);
            setIdsFaltasConCheck(tempIds);
        }
    };


    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
            {rows.map((row) => (
                <tr key={row.IdFalta}>
                    <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center">
                            {fromAdminPage === true && row.PuedeAprobar === true &&
                                <input type="checkbox" onClick={(e) => checkboxClic(e, row)}></input>}
                            {row.FechaRegistro}
                        </div>
                    </td>
                    <td className="text-center">{row.TipoFalta}</td>
                    <td className="text-center">{row.EstadoEmpleado}</td>
                    <td className="text-center">{row.NombreEmpleado}</td>
                    <td className="text-center">{row.Departamento}</td>
                    <td className="text-center">{row.Cargo}</td>
                    <td className="text-center">{row.Sede}</td>
                    <td className="text-center">{row.FechaInicioText}</td>
                    <td className="text-center">{row.FechaFinText}</td>
                    <td className="text-center">{row.CantidadDias}</td>
                    <td className="text-center">{row.Estado}</td>
                    <td className="text-center">

                        <ActionsIcons>
                            <FontAwesomeIcon
                                icon="id-card"
                                title="Ver Detalle Falta"
                                size="lg"
                                onClick={(e) => {
                                    if (e)
                                        e.preventDefault();
                                    setModalEnabled({
                                        isEnable: true,
                                        component: DetalleFalta,
                                        data: {row, fromAdminPage: fromAdminPage, manageSearch},
                                    })
                                }

                                }
                            />
                        </ActionsIcons>

                    </td>
                </tr>
            ))}
            </tbody>
        </PageTable>
    );
}

export default TableFaltas;
